import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireforpartyeventsinpune() {



  const cardData =
  {
    keyword: 'Bus Hire for Party Events in Pune',
    heading: 'Amruta Travels: Bus Hire for Party Events in Pune',
    headingDescription: 'Amruta Travels Pvt. Ltd. provides Bus Hire for Party Events in Pune, offering stylish and comfortable transportation for birthdays, bachelor parties, family gatherings, and corporate celebrations. Our luxury AC and Non-AC buses come equipped with plush seating, ambient lighting, air conditioning, and premium sound systems, ensuring a festive atmosphere from start to finish. Whether it’s a night out with friends or a grand family celebration, our professional chauffeurs ensure safety, punctuality, and a smooth travel experience across Pune, Pimpri Chinchwad, and nearby areas. With flexible booking options and well-maintained vehicles, Amruta Travels’ Party Bus Rental in Pune is the perfect choice for hassle-free, fun-filled group travel that adds a touch of luxury to every event.',

    top: 'Top Places to Visit in Pune with Amruta Travels',

"topPlaces": [
    {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, visited by millions of devotees annually. Its magnificently decorated Lord Ganesha idol radiates devotion and serenity. During Ganesh Chaturthi, the temple comes alive with lights, chants, and celebrations. It stands as Pune’s beacon of faith and divine grace in the heart of the city."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched on a rugged hill about 30 km from the city, Sinhagad Fort offers breathtaking views of the Sahyadri ranges. The fort is famed for the heroic battle led by Tanaji Malusare under Chhatrapati Shivaji Maharaj’s command. Visitors enjoy trekking, exploring ancient ruins, and savoring local snacks like pithla-bhakri. Sinhagad Fort embodies Pune’s valor, nature, and nostalgia in one frame."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut shrine carved out of basalt in the 8th century. Dedicated to Lord Shiva, the temple’s circular Nandi pavilion and stone pillars display remarkable craftsmanship. Nestled in the city center, it provides a tranquil escape from urban life. Pataleshwar Temple connects modern Pune to its timeless spiritual legacy."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering a blend of spirituality and scenic beauty. The temple complex atop the hill, dedicated to Lord Shiva and Goddess Parvati, was built by the Peshwas. Climbing its 108 steps rewards visitors with panoramic city views and a peaceful ambiance. Parvati Hill is Pune’s perfect fusion of devotion, history, and natural charm."
  },
    {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an architectural masterpiece and a national monument of India’s freedom movement. Constructed in 1892, it served as a detention site for Mahatma Gandhi and his associates during the Quit India Movement. The palace’s sprawling gardens, museum, and Gandhi memorial exude peace and history. It is Pune’s enduring tribute to the nation’s struggle for independence."
  },
   {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada stands as the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas. Once the seat of the Maratha Empire, it boasts grand gates, intricately carved arches, and sprawling courtyards. The evening light and sound show vividly narrates tales of valor and tragedy. With its rich history and majestic aura, Shaniwar Wada remains the soul of Pune’s cultural identity."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of over 20,000 rare artifacts collected from across India. From musical instruments to traditional ornaments and sculptures, it offers a fascinating glimpse into India’s past. Each exhibit tells a story of art, culture, and human creativity. It’s a must-visit cultural gem for those exploring Pune’s heritage."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a serene sanctuary that draws visitors from all over the world. Set amid lush gardens and modern architecture, it offers meditation, wellness programs, and personal growth workshops. The peaceful environment helps people reconnect with their inner selves. Osho Ashram is Pune’s global destination for spirituality and transformation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a picturesque reservoir surrounded by rolling hills and greenery, just a short drive from Pune. It’s the main water source for the city and a favorite spot for picnics and evening drives. The scenic view of shimmering waters during sunset is mesmerizing. Khadakwasla offers Pune residents the perfect weekend retreat close to nature."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "The Pune Okayama Friendship Garden, inspired by Japan’s famous Korakuen Garden, blends Japanese landscaping with Indian flora. Its lush lawns, small bridges, flowing streams, and walking paths create a soothing environment for relaxation. Named after writer Pu La Deshpande, it’s ideal for families and photographers alike. The garden represents Pune’s bond of global friendship and aesthetic beauty."
  }
],



    "services": [
    {
      "name": "Bus Hire for Party Events in Pune",
      "description": "Bus Hire for Party Events in Pune provides vibrant and stylish buses tailored for celebrations, birthdays, and other special occasions. These buses come equipped with modern sound systems, comfortable seating, and lighting to create the perfect party atmosphere on the move. Professional drivers ensure safe and timely transport so you can focus on enjoying the event."
    },
    {
      "name": "Party Bus Rental Pune",
      "description": "Party Bus Rental Pune offers a range of buses designed specifically for parties, including birthday bashes, corporate celebrations, and social gatherings. These buses are fitted with premium amenities like dance floors, LED lighting, and powerful music systems to elevate your party experience while on the road."
    },
    {
      "name": "Celebration Bus Pune",
      "description": "Celebration Bus Pune specializes in buses that cater to all kinds of celebrations and festive events. Whether it’s a milestone birthday, anniversary, or graduation party, these buses provide a lively and fun environment with ample space, entertainment features, and reliable service for a memorable journey."
    },
    {
      "name": "Birthday Party Bus Pune",
      "description": "Birthday Party Bus Pune is dedicated to making birthdays unforgettable with buses equipped with colorful lighting, music systems, and comfortable interiors. These buses accommodate groups of all sizes and offer flexible booking options to suit your party schedule and route preferences."
    },
    {
      "name": "Event Bus Hire Pune",
      "description": "Event Bus Hire Pune caters to a wide variety of events, from corporate parties to community gatherings. These buses offer spacious interiors and entertainment amenities to keep guests engaged while traveling between venues, ensuring a smooth and enjoyable experience."
    },
    {
      "name": "DJ Bus Pune",
      "description": "DJ Bus Pune features buses equipped with professional-grade DJ systems, lighting, and sound equipment to deliver a club-like atmosphere on wheels. Ideal for music lovers and party enthusiasts, this service transforms your bus ride into an unforgettable dance party."
    },
    {
      "name": "AC Party Bus Pune",
      "description": "AC Party Bus Pune combines comfort with fun by offering fully air-conditioned party buses. These buses maintain a cool environment regardless of Pune’s weather, enhancing the overall party experience with premium sound and lighting systems."
    },
    {
      "name": "Luxury Party Bus Pune",
      "description": "Luxury Party Bus Pune offers high-end party buses with plush interiors, premium entertainment setups, and exclusive amenities. Perfect for VIP parties, corporate celebrations, and weddings, these buses deliver an upscale and stylish party environment."
    },
    {
      "name": "Mini Party Bus Pune",
      "description": "Mini Party Bus Pune caters to smaller groups looking for a compact yet lively party experience. These buses provide all the essential party features, such as quality sound systems and lighting, in a smaller vehicle that’s easy to maneuver and book for intimate celebrations."
    },
    {
      "name": "Party Bus Hire in Hinjewadi",
      "description": "Party Bus Hire in Hinjewadi offers localized party bus rental services catering to the corporate and social crowd of the IT hub. These buses are perfect for office celebrations, team outings, and social events, featuring modern amenities and professional drivers."
    },
    {
      "name": "Party Bus Hire in Baner",
      "description": "Party Bus Hire in Baner delivers stylish party buses for local celebrations, including birthdays, bachelor/bachelorette parties, and group outings. Known for punctuality and quality service, this option ensures a memorable and fun party ride."
    },
    {
      "name": "Party Bus Hire in Hadapsar",
      "description": "Party Bus Hire in Hadapsar specializes in providing party buses for various celebrations in the Hadapsar area. Equipped with excellent sound and lighting systems, these buses make your event lively and exciting while ensuring safety and comfort."
    },
    {
      "name": "Party Bus Hire in Pimpri",
      "description": "Party Bus Hire in Pimpri caters to the social and corporate events of Pimpri Chinchwad, offering party buses equipped with entertainment systems and comfortable seating. Ideal for group parties, these buses guarantee fun and hassle-free travel."
    },
    {
      "name": "Affordable Party Bus Pune",
      "description": "Affordable Party Bus Pune provides cost-effective party bus rental options without compromising on quality or entertainment features. This service is popular among budget-conscious clients seeking a vibrant party atmosphere with reliable transportation."
    },
    {
      "name": "Party Coach Pune",
      "description": "Party Coach Pune offers larger coach-style buses customized for big celebrations and group parties. These coaches feature spacious interiors, advanced sound and lighting systems, and ample space for dancing and socializing, perfect for large groups."
    },
    {
      "name": "Bus Booking for Events Pune",
      "description": "Bus Booking for Events Pune provides easy and quick booking services for party buses and event transportation. Customers benefit from seamless online booking, flexible scheduling, and a variety of bus options to suit any party size or event type."
    },
    {
      "name": "Party Bus near Me Pune",
      "description": "Party Bus near Me Pune ensures quick and localized access to party buses across Pune. This service emphasizes fast response times, convenient pick-up locations, and professional drivers to make party transportation effortless and fun."
    },
    {
      "name": "Wedding Party Bus Pune",
      "description": "Wedding Party Bus Pune specializes in providing party buses for wedding celebrations, including pre-wedding parties and guest transportation. These buses combine festive decor, excellent entertainment systems, and reliable service to add excitement and convenience to your special day."
    }
  ],
  "tableData": [
    ["Bus Hire for Party Events in Pune", "Party Bus Rental Pune"],
    ["Celebration Bus Pune", "Birthday Party Bus Pune"],
    ["Event Bus Hire Pune", "DJ Bus Pune"],
    ["AC Party Bus Pune", "Luxury Party Bus Pune"],
    ["Mini Party Bus Pune", "Party Bus Hire in Hinjewadi"],
    ["Party Bus Hire in Baner", "Party Bus Hire in Hadapsar"],
    ["Party Bus Hire in Pimpri", "Affordable Party Bus Pune"],
    ["Party Coach Pune", "Bus Booking for Events Pune"],
    ["Party Bus near Me Pune", "Wedding Party Bus Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Bus Hire for Party Events in Pune",
    "WhyChoosedescription": "Amruta Travels Pvt Ltd offers stylish and reliable bus hire services for party events in Pune, ensuring a fun and comfortable group travel experience."
  },
  {
    "WhyChooseheading": "Variety of Bus Sizes Available",
    "WhyChoosedescription": "Select from multiple seating options to fit your party size, from intimate groups to large celebrations."
  },
  {
    "WhyChooseheading": "Well-Maintained and Clean Buses",
    "WhyChoosedescription": "Our buses are regularly serviced and sanitized to provide a safe, hygienic, and enjoyable ride."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "Get upfront pricing with no hidden charges, making your party transportation hassle-free and budget-friendly."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose hourly, daily, or custom rental options tailored to your party’s schedule and needs."
  },
  {
    "WhyChooseheading": "Professional and Friendly Drivers",
    "WhyChoosedescription": "Our experienced drivers ensure timely pickups, safe driving, and courteous service throughout your event."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated team is available around the clock to assist with bookings, changes, and any special requests."
  },
  {
    "WhyChooseheading": "Easy and Quick Booking Process",
    "WhyChoosedescription": "Book your party bus hassle-free online or by phone, with prompt service across Pune."
  }
]


















  }

const faqData = [
  {
    question: 'Does Amruta Travels Pvt Ltd offer bus hire services for party events in Pune?',
    answer: 'Yes, Amruta Travels Pvt Ltd provides reliable and comfortable bus hire services specifically for party events in Pune.',
  },
  {
    question: 'How can I book a bus for a party event in Pune with Amruta Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24×7 customer support team in Pune.',
  },
  {
    question: 'What types of buses are available for party event hires in Pune?',
    answer: 'We offer a variety of buses including mini buses, 17 seater Urbania, 35 seater, 45 seater, 50 seater, and 53 seater buses to accommodate your party group size.',
  },
  {
    question: 'Are the drivers experienced and trained for party event bus hires in Pune?',
    answer: 'Yes, all drivers are professional, courteous, and experienced in providing safe and comfortable rides for party events.',
  },
  {
    question: 'Can buses be hired for birthday parties, bachelor parties, and other celebrations in Pune?',
    answer: 'Absolutely. Our buses are perfect for birthday parties, bachelor parties, anniversaries, and other party events.',
  },
  {
    question: 'Is the bus hire service for party events available 24×7 in Pune?',
    answer: 'Yes, Amruta Travels offers 24×7 availability for party event bus hires in Pune to fit your schedule.',
  },
  {
    question: 'What safety and hygiene protocols are followed for party event bus hires?',
    answer: 'All vehicles are sanitized thoroughly before every trip, and drivers follow strict hygiene and safety measures.',
  },
  {
    question: 'What payment options are accepted for party event bus hires in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for your convenience.',
  },
  {
    question: 'Is customer support available during the party event bus hire period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your party event bus hire.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Singh',
    feedback: 'The bus hire service from Amruta Travels Pune made our birthday party transport seamless and fun. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Deshmukh',
    feedback: 'Great experience hiring a bus for our bachelor party. The driver was professional and the bus was comfortable.',
    rating: 5,
  },
];




































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "24 Seater Bus for Rent in Pune", link: "24-seater-bus-for-rent-in-pune" },
  { place: "/images/keyword/2.jpg", text: "16 Seater Urbania for Rent in Pune", link: "16-seater-urbania-for-rent-in-pune" },
  { place: "/images/keyword/3.jpg", text: "14 Seater Urbania Hire in Pune", link: "14-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/4.jpg", text: "17 Seater Urbania Hire in Pune", link: "17-seater-urbania-hire-in-pune" },
  { place: "/images/keyword/5.jpg", text: "Mini Bus On Rent in Pimpri Chinchwad", link: "mini-bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/6.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
  { place: "/images/keyword/7.jpg", text: "Force Urbania 17 Seater On Rent in Pune", link: "force-urbania-17-seater-on-rent-in-pune" },
  { place: "/images/keyword/8.jpg", text: "35 Seater Bus On Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/9.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/10.jpg", text: "53 Seater Bus On Rent in Pune", link: "53-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/11.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
  { place: "/images/keyword/12.jpg", text: "Bus On Rent in Pune", link: "bus-on-rent-in-pune" },
  { place: "/images/keyword/13.jpg", text: "Bus Hire in Pune", link: "bus-hire-in-pune" },
  { place: "/images/keyword/14.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
  { place: "/images/keyword/15.jpg", text: "Bus Rental for Corporate Events in Pune", link: "bus-rental-for-corporate-events-in-pune" },
  { place: "/images/keyword/16.jpg", text: "Wedding Bus Booking Online Pune", link: "wedding-bus-booking-online-pune" },
  { place: "/images/keyword/17.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
  { place: "/images/keyword/18.jpg", text: "Bus Hire for Party Events in Pune", link: "bus-hire-for-party-events-in-pune" },
  { place: "/images/keyword/19.jpg", text: "Full Bus Booking for Marriage Pune", link: "full-bus-booking-for-marriage-pune" },
  { place: "/images/keyword/20.jpg", text: "AC Luxury Bus On Rent in Pune", link: "ac-luxury-bus-on-rent-in-pune" },
  { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
  { place: "/images/keyword/22.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "luxury-force-urbania-on-rent-in-pune" },
  { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Pune for Corporate", link: "urbania-on-rent-in-pune-for-corporate" },
  { place: "/images/keyword/24.jpg", text: "Pune to Goa Urbania On Rent", link: "pune-to-goa-urbania-on-rent" },
  { place: "/images/keyword/25.jpg", text: "Pune to Mumbai Urbania on Rent", link: "pune-to-mumbai-urbania-on-rent" }
];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for Party Events in Pune",
  "image": "https://www.amrutatravelspvtltd.com/images/keyword/18.jpg",
  "description": "Book Bus Hire for Party Events in Pune with Amruta Travels Pvt. Ltd. offering Luxury, AC, and DJ-equipped party buses for birthdays, celebrations, weddings, and corporate events. Enjoy a fun-filled ride with our premium party bus rental in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels Pvt. Ltd."
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "14950"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5200",
    "availability": "https://schema.org/InStock",
    "url": "https://www.amrutatravelspvtltd.com/bus-hire-for-party-events-in-pune"
  }
};









  return (
    <div>
<Helmet>
  <title>Bus Hire for Party Events in Pune | Luxury & DJ Party Bus Rental | Amruta Travels Pvt. Ltd.</title>
  <meta
    name="description"
    content="Book Bus Hire for Party Events in Pune with Amruta Travels Pvt. Ltd. offering Luxury, AC, and DJ buses for birthdays, celebrations, weddings, and corporate parties. Affordable and exciting party bus rental in Pune."
  />
  <meta
    name="keywords"
    content="Bus Hire for Party Events in Pune, Party Bus Rental Pune, Celebration Bus Pune, Birthday Party Bus Pune, Event Bus Hire Pune, DJ Bus Pune, AC Party Bus Pune, Luxury Party Bus Pune, Mini Party Bus Pune, Party Bus Hire in Hinjewadi, Party Bus Hire in Baner, Party Bus Hire in Hadapsar, Party Bus Hire in Pimpri, Affordable Party Bus Pune, Party Coach Pune, Bus Booking for Events Pune, Party Bus near Me Pune, Wedding Party Bus Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section className="page-header">
        <div
          className="page-header__bg"
          style={{
            backgroundImage: "url(/images/page-header-bg-1-1.jpg)",
          }}
        ></div>
        <div className="container">
          <div className="page-header__content">
            <h2 className="page-header__title">   {cardData.keyword}</h2>
          </div>
        </div>
      </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/18.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Amruta Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Amruta Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918010014995" className="pc-call">+91 8010014995</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918010014995"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918010014995" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@amrutatravelspvtltd.com" className="pc-email">
                      booking@amrutatravelspvtltd.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Amruta Travels Pvt Ltd</strong><br />
                      Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireforpartyeventsinpune;